import type { CalendarEvent } from '../types';

interface RawTaskEvent {
  id: string;
  title: string;
  dueDate: string;
  startDate?: string;
}

type EventAdapter<TRaw> = (items: TRaw[]) => CalendarEvent[];

export const taskAdapter: EventAdapter<RawTaskEvent> = (items) =>
  items.map((item) => {
    const start = item.startDate ? new Date(item.startDate) : new Date(item.dueDate);
    const end = new Date(item.dueDate);

    return {
      id: item.id,
      title: item.title,
      start,
      end,
      allDay: true,
      type: 'task',
      source: 'internal',
      metadata: { dueDate: item.dueDate, startDate: item.startDate },
    };
  });
